import EmailCallout from './email-callout'

export default EmailCallout
